import { getServerResponse } from '../functions';
import { showLoader, hideLoader } from '.';
import moment from "moment";

// #228 WcnDealHomework.getTaskListByMonth
export const getTaskListByMonth = (month, year) => {

    return async (dispatch, getState) => {
        let { userInfo } = getState().auth;
        if (!month || !year) {
            let check = moment(new Date(), 'YYYY/MM/DD');
            month = check.format('M');
            year = check.format('YYYY');
        }
        try {
            let response = await getServerResponse({
                cmd: "WcnDealHomework.getTaskListByMonth",
                token: userInfo.token,
                year,
                month
            })
            if (response.error) return;
            return response
        } catch (error) {
            console.log("WcnDealHomework.getTaskListByMonth", error)
        }
    }
};

// #230 WcnDealHomework.getTaskByDay
export const getTaskByDay = (date) => {

    return async (dispatch, getState) => {
        let { userInfo } = getState().auth;
        try {
            dispatch(showLoader());
            let response = await getServerResponse({
                cmd: "WcnDealHomework.getTaskByDay",
                token: userInfo.token,
                date
            })
            dispatch(hideLoader());
            if (response.error) return;
            return response
        } catch (error) {
            dispatch(hideLoader());
            console.log("WcnDealHomework.getTaskByDay", error)
        }
    }
};

// #231 WcnDealHomework.getMyStudents
export const getMyStudents = () => {

    return async (dispatch, getState) => {
        let { userInfo } = getState().auth;
        try {
            let response = await getServerResponse({
                cmd: "WcnDealHomework.getMyStudents",
                token: userInfo.token
            })
            if (response.error) return;
            return response
        } catch (error) {
            console.log("WcnDealHomework.getMyStudents", error)
        }
    }
};

// #235 WcnDealHomework.getAllUnit
export const getAllUnit = () => {

    return async (dispatch, getState) => {
        let { userInfo } = getState().auth;
        try {
            let response = await getServerResponse({
                cmd: "WcnDealHomework.getAllUnit",
                token: userInfo.token
            })
            if (response.error) return;
            return response
        } catch (error) {
            console.log("WcnDealHomework.getAllUnit", error)
        }
    }
};

// #236 WcnDealHomework.getAllLesson
export const getAllLesson = (unit) => {

    return async (dispatch, getState) => {
        let { userInfo } = getState().auth;
        try {
            let response = await getServerResponse({
                cmd: "WcnDealHomework.getAllLesson",
                token: userInfo.token,
                unit
            })
            if (response.error) return;
            return response
        } catch (error) {
            console.log("WcnDealHomework.getAllLesson", error)
        }
    }
};

// #237 WcnDealHomework.addTask
export const addTask = ({ students, task, comment, expiration }) => {

    return async (dispatch, getState) => {
        let { userInfo } = getState().auth;
        try {
            dispatch(showLoader());
            let response = await getServerResponse({
                cmd: "WcnDealHomework.addTask",
                token: userInfo.token,
                students,
                task,
                comment,
                expiration
            })
            dispatch(hideLoader());
            if (response.error) return;
            return response
        } catch (error) {
            dispatch(hideLoader());
            console.log("WcnDealHomework.addTask", error)
        }
    }
};

// #229 WcnDealHomework.getTaskDetails
export const getTaskDetails = (task_id) => {

    return async (dispatch, getState) => {
        let { userInfo } = getState().auth;
        try {
            dispatch(showLoader());
            let response = await getServerResponse({
                cmd: "WcnDealHomework.getTaskDetails",
                token: userInfo.token,
                id: task_id
            })
            dispatch(hideLoader());
            if (response.error) return;
            return response
        } catch (error) {
            dispatch(hideLoader());
            console.log("WcnDealHomework.getTaskDetails", error)
        }
    }
};


// #232 WcnDealHomework.abortTask
export const abortTask = ({ id, student }) => {

    return async (dispatch, getState) => {
        let { userInfo } = getState().auth;
        try {
            let response = await getServerResponse({
                cmd: "WcnDealHomework.abortTask",
                token: userInfo.token,
                id,
                entire: student ? false : true,
                student
            })
            console.log(response)
            if (response.error) return;
            return response
        } catch (error) {
            console.log("WcnDealHomework.abortTask", error)
        }
    }
};

// #233 WcnDealHomework.getTaskResult
export function getTaskResult(id) {
    return async (dispatch, getState) => {
        let { userInfo } = getState().auth;
        try {
            dispatch(showLoader());
            let response = await getServerResponse({
                cmd: "WcnDealHomework.getTaskResult",
                token: userInfo.token,
                id
            })
            dispatch(hideLoader());
            if (response.error || response === 400 || response === "400") return;
            return response
        } catch (error) {
            dispatch(hideLoader());
            console.log("WcnDealHomework.getTaskResult", error)
        }
    }
}

// #233 WcnDealHomework.getLessonRecords
export function getHomeworkLessonRecords({ user_id, unit, lesson }) {
    return async (dispatch, getState) => {
        let { userInfo } = getState().auth;
        try {
            let response = await getServerResponse({
                cmd: "WcnDealHomework.getLessonRecords",
                token: userInfo.token,
                user_id,
                unit,
                lesson
            })
            if (response.error || response === 400 || response === "400") return;
            return response
        } catch (error) {
            console.log("WcnDealHomework.getLessonRecords", error)
        }
    }
}